import { OrganizationInformationPane } from '@/components/organizations/Detail/components/Overview';

export default OrganizationInformationPane;
